"use strict";

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Particle = void 0;

var Updater_1 = require("./Particle/Updater");

var Particles_1 = require("../Options/Classes/Particles/Particles");

var Shape_1 = require("../Options/Classes/Particles/Shape/Shape");

var Enums_1 = require("../Enums");

var Utils_1 = require("../Utils");

var Infecter_1 = require("./Particle/Infecter");

var Mover_1 = require("./Particle/Mover");

var Particle = /*#__PURE__*/function () {
  function Particle(container, position, overrideOptions) {
    _classCallCheck(this, Particle);

    var _a, _b, _c, _d, _e, _f, _g, _h, _j;

    this.container = container;
    this.fill = true;
    this.close = true;
    this.links = [];
    this.lastNoiseTime = 0;
    this.destroyed = false;
    var options = container.options;
    var particlesOptions = new Particles_1.Particles();
    particlesOptions.load(options.particles);
    var shapeType = particlesOptions.shape.type;
    this.shape = shapeType instanceof Array ? Utils_1.Utils.itemFromArray(shapeType) : shapeType;

    if (overrideOptions === null || overrideOptions === void 0 ? void 0 : overrideOptions.shape) {
      if (overrideOptions.shape.type) {
        var overrideShapeType = overrideOptions.shape.type;
        this.shape = overrideShapeType instanceof Array ? Utils_1.Utils.itemFromArray(overrideShapeType) : overrideShapeType;
      }

      var shapeOptions = new Shape_1.Shape();
      shapeOptions.load(overrideOptions.shape);

      if (this.shape) {
        var shapeData = shapeOptions.options[this.shape];

        if (shapeData) {
          this.shapeData = Utils_1.Utils.deepExtend({}, shapeData instanceof Array ? Utils_1.Utils.itemFromArray(shapeData) : shapeData);
        }
      }
    } else {
      var _shapeData = particlesOptions.shape.options[this.shape];

      if (_shapeData) {
        this.shapeData = Utils_1.Utils.deepExtend({}, _shapeData instanceof Array ? Utils_1.Utils.itemFromArray(_shapeData) : _shapeData);
      }
    }

    if (overrideOptions !== undefined) {
      particlesOptions.load(overrideOptions);
    }

    if (((_a = this.shapeData) === null || _a === void 0 ? void 0 : _a.particles) !== undefined) {
      particlesOptions.load((_b = this.shapeData) === null || _b === void 0 ? void 0 : _b.particles);
    }

    this.fill = (_d = (_c = this.shapeData) === null || _c === void 0 ? void 0 : _c.fill) !== null && _d !== void 0 ? _d : this.fill;
    this.close = (_f = (_e = this.shapeData) === null || _e === void 0 ? void 0 : _e.close) !== null && _f !== void 0 ? _f : this.close;
    this.particlesOptions = particlesOptions;
    var noiseDelay = this.particlesOptions.move.noise.delay;
    this.noiseDelay = (noiseDelay.random.enable ? Utils_1.Utils.randomInRange(noiseDelay.random.minimumValue, noiseDelay.value) : noiseDelay.value) * 1000;
    container.retina.initParticle(this);
    var color = this.particlesOptions.color;
    var sizeValue = (_g = this.sizeValue) !== null && _g !== void 0 ? _g : container.retina.sizeValue;
    var randomSize = typeof this.particlesOptions.size.random === "boolean" ? this.particlesOptions.size.random : this.particlesOptions.size.random.enable;
    this.size = {
      value: randomSize && this.randomMinimumSize !== undefined ? Utils_1.Utils.randomInRange(this.randomMinimumSize, sizeValue) : sizeValue
    };
    this.direction = this.particlesOptions.move.direction;
    this.bubble = {
      inRange: false
    };
    this.initialVelocity = this.calculateVelocity();
    this.velocity = {
      horizontal: this.initialVelocity.horizontal,
      vertical: this.initialVelocity.vertical
    };
    var rotateOptions = this.particlesOptions.rotate;
    var degAngle = rotateOptions.random ? Math.random() * 360 : rotateOptions.value;
    this.angle = degAngle * Math.PI / 180;
    this.pathAngle = Math.atan2(this.initialVelocity.vertical, this.initialVelocity.horizontal);
    this.rotateDirection = rotateOptions.direction;

    if (this.rotateDirection === Enums_1.RotateDirection.random) {
      var index = Math.floor(Math.random() * 2);
      this.rotateDirection = index > 0 ? Enums_1.RotateDirection.counterClockwise : Enums_1.RotateDirection.clockwise;
    }

    var sizeAnimation = this.particlesOptions.size.animation;

    if (sizeAnimation.enable) {
      switch (sizeAnimation.startValue) {
        case Enums_1.StartValueType.min:
          if (!randomSize) {
            var pxRatio = container.retina.pixelRatio;
            this.size.value = sizeAnimation.minimumValue * pxRatio;
          }

          break;
      }

      this.size.status = Enums_1.SizeAnimationStatus.increasing;
      this.size.velocity = ((_h = this.sizeAnimationSpeed) !== null && _h !== void 0 ? _h : container.retina.sizeAnimationSpeed) / 100;

      if (!sizeAnimation.sync) {
        this.size.velocity *= Math.random();
      }
    }

    this.color = Utils_1.ColorUtils.colorToHsl(color);
    var colorAnimation = this.particlesOptions.color.animation;

    if (colorAnimation.enable) {
      this.colorVelocity = colorAnimation.speed / 100;

      if (!colorAnimation.sync) {
        this.colorVelocity = this.colorVelocity * Math.random();
      }
    } else {
      this.colorVelocity = 0;
    }

    if (colorAnimation.enable && !colorAnimation.sync && this.color) {
      this.color.h = Math.random() * 360;
    }

    this.position = this.calcPosition(this.container, position);
    this.offset = {
      x: 0,
      y: 0
    };

    if (this.particlesOptions.collisions.enable && !this.checkOverlap(position)) {
      throw new Error();
    }

    var opacityOptions = this.particlesOptions.opacity;
    var randomOpacity = opacityOptions.random;
    var opacityValue = opacityOptions.value;
    this.opacity = {
      value: randomOpacity.enable ? Utils_1.Utils.randomInRange(randomOpacity.minimumValue, opacityValue) : opacityValue
    };
    var opacityAnimation = opacityOptions.animation;

    if (opacityAnimation.enable) {
      this.opacity.status = Enums_1.OpacityAnimationStatus.increasing;
      this.opacity.velocity = opacityAnimation.speed / 100;

      if (!opacityAnimation.sync) {
        this.opacity.velocity *= Math.random();
      }
    }

    var drawer = container.drawers.get(this.shape);

    if (!drawer) {
      drawer = Utils_1.Plugins.getShapeDrawer(this.shape);

      if (drawer) {
        container.drawers.set(this.shape, drawer);
      }
    }

    var imageShape = this.loadImageShape(container, drawer);

    if (imageShape) {
      this.image = imageShape.image;
      this.fill = imageShape.fill;
      this.close = imageShape.close;
    }

    this.stroke = this.particlesOptions.stroke instanceof Array ? Utils_1.Utils.itemFromArray(this.particlesOptions.stroke) : this.particlesOptions.stroke;
    this.strokeWidth = this.stroke.width * container.retina.pixelRatio;
    this.strokeColor = Utils_1.ColorUtils.colorToHsl(this.stroke.color);

    if (typeof this.stroke.color !== "string") {
      var strokeColorAnimation = (_j = this.stroke.color) === null || _j === void 0 ? void 0 : _j.animation;

      if (strokeColorAnimation && this.strokeColor) {
        if (strokeColorAnimation.enable) {
          this.strokeColorVelocity = colorAnimation.speed / 100;

          if (!strokeColorAnimation.sync) {
            this.strokeColorVelocity = this.strokeColorVelocity * Math.random();
          }
        } else {
          this.strokeColorVelocity = 0;
        }

        if (strokeColorAnimation.enable && !strokeColorAnimation.sync && this.color) {
          this.strokeColor.h = Math.random() * 360;
        }
      }
    }

    this.shadowColor = Utils_1.ColorUtils.colorToRgb(this.particlesOptions.shadow.color);
    this.updater = new Updater_1.Updater(container, this);
    this.infecter = new Infecter_1.Infecter(container, this);
    this.mover = new Mover_1.Mover(container, this);
  }

  _createClass(Particle, [{
    key: "move",
    value: function move(delta) {
      this.mover.move(delta);
    }
  }, {
    key: "update",
    value: function update(delta) {
      this.updater.update(delta);
    }
  }, {
    key: "draw",
    value: function draw(delta) {
      this.container.canvas.drawParticle(this, delta);
    }
  }, {
    key: "isOverlapping",
    value: function isOverlapping() {
      var _this = this;

      var container = this.container;
      var collisionFound = false;
      var pos1 = this.getPosition();

      var _iterator = _createForOfIteratorHelper(container.particles.array.filter(function (t) {
        return t != _this;
      })),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var p2 = _step.value;
          var pos2 = p2.getPosition();
          var dist = Utils_1.Utils.getDistance(pos1, pos2);

          if (dist <= this.size.value + p2.size.value) {
            collisionFound = true;
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return collisionFound;
    }
  }, {
    key: "getPosition",
    value: function getPosition() {
      return {
        x: this.position.x + this.offset.x,
        y: this.position.y + this.offset.y
      };
    }
  }, {
    key: "getFillColor",
    value: function getFillColor() {
      var _a;

      return (_a = this.bubble.color) !== null && _a !== void 0 ? _a : this.color;
    }
  }, {
    key: "getStrokeColor",
    value: function getStrokeColor() {
      var _a, _b;

      return (_b = (_a = this.bubble.color) !== null && _a !== void 0 ? _a : this.strokeColor) !== null && _b !== void 0 ? _b : this.color;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.destroyed = true;
    }
  }, {
    key: "checkOverlap",
    value: function checkOverlap(position) {
      var iterations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var container = this.container;

      if (!container.particles.count) {
        return true;
      }

      if (iterations >= container.particles.count) {
        return false;
      }

      var overlapping = this.isOverlapping();

      if (overlapping) {
        this.position.x = position ? position.x : Math.random() * container.canvas.size.width;
        this.position.y = position ? position.y : Math.random() * container.canvas.size.height;
        return this.checkOverlap(undefined, iterations + 1);
      }

      return true;
    }
  }, {
    key: "calcPosition",
    value: function calcPosition(container, position) {
      var _a, _b;

      var _iterator2 = _createForOfIteratorHelper(container.plugins),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _slicedToArray(_step2.value, 2),
              plugin = _step2$value[1];

          var pluginPos = plugin.particlePosition !== undefined ? plugin.particlePosition(position, this) : undefined;

          if (pluginPos !== undefined) {
            return Utils_1.Utils.deepExtend({}, pluginPos);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      var pos = {
        x: (_a = position === null || position === void 0 ? void 0 : position.x) !== null && _a !== void 0 ? _a : Math.random() * container.canvas.size.width,
        y: (_b = position === null || position === void 0 ? void 0 : position.y) !== null && _b !== void 0 ? _b : Math.random() * container.canvas.size.height
      };
      var outMode = this.particlesOptions.move.outMode;

      if (Utils_1.Utils.isInArray(outMode, Enums_1.OutMode.bounce) || Utils_1.Utils.isInArray(outMode, Enums_1.OutMode.bounceHorizontal)) {
        if (pos.x > container.canvas.size.width - this.size.value * 2) {
          pos.x -= this.size.value;
        } else if (pos.x < this.size.value * 2) {
          pos.x += this.size.value;
        }
      }

      if (Utils_1.Utils.isInArray(outMode, Enums_1.OutMode.bounce) || Utils_1.Utils.isInArray(outMode, Enums_1.OutMode.bounceVertical)) {
        if (pos.y > container.canvas.size.height - this.size.value * 2) {
          pos.y -= this.size.value;
        } else if (pos.y < this.size.value * 2) {
          pos.y += this.size.value;
        }
      }

      return pos;
    }
  }, {
    key: "calculateVelocity",
    value: function calculateVelocity() {
      var baseVelocity = Utils_1.Utils.getParticleBaseVelocity(this);
      var res = {
        horizontal: 0,
        vertical: 0
      };
      var moveOptions = this.particlesOptions.move;
      var rad;
      var radOffset = Math.PI / 4;

      if (typeof moveOptions.angle === "number") {
        rad = Math.PI / 180 * moveOptions.angle;
      } else {
        rad = Math.PI / 180 * moveOptions.angle.value;
        radOffset = Math.PI / 180 * moveOptions.angle.offset;
      }

      var range = {
        left: Math.sin(radOffset + rad / 2) - Math.sin(radOffset - rad / 2),
        right: Math.cos(radOffset + rad / 2) - Math.cos(radOffset - rad / 2)
      };

      if (moveOptions.straight) {
        res.horizontal = baseVelocity.x;
        res.vertical = baseVelocity.y;

        if (moveOptions.random) {
          res.horizontal += Utils_1.Utils.randomInRange(range.left, range.right) / 2;
          res.vertical += Utils_1.Utils.randomInRange(range.left, range.right) / 2;
        }
      } else {
        res.horizontal = baseVelocity.x + Utils_1.Utils.randomInRange(range.left, range.right) / 2;
        res.vertical = baseVelocity.y + Utils_1.Utils.randomInRange(range.left, range.right) / 2;
      }

      return res;
    }
  }, {
    key: "loadImageShape",
    value: function loadImageShape(container, drawer) {
      var _this2 = this;

      var _a, _b, _c, _d;

      if (!(this.shape === Enums_1.ShapeType.image || this.shape === Enums_1.ShapeType.images)) {
        return;
      }

      var shape = this.particlesOptions.shape;
      var imageDrawer = drawer;
      var imagesOptions = shape.options[this.shape];
      var images = imageDrawer.getImages(container).images;
      var image = Utils_1.Utils.itemFromArray(images);
      var optionsImage = imagesOptions instanceof Array ? imagesOptions.find(function (t) {
        return t.src === image.source;
      }) : imagesOptions;
      var color = this.getFillColor();
      var imageRes;

      if ((image === null || image === void 0 ? void 0 : image.svgData) !== undefined && optionsImage.replaceColor && color) {
        var svgColoredData = Utils_1.ColorUtils.replaceColorSvg(image, color, this.opacity.value);
        var svg = new Blob([svgColoredData], {
          type: "image/svg+xml"
        });
        var domUrl = window.URL || window.webkitURL || window;
        var url = domUrl.createObjectURL(svg);
        var img = new Image();
        imageRes = {
          data: image,
          loaded: false,
          ratio: optionsImage.width / optionsImage.height,
          replaceColor: (_a = optionsImage.replaceColor) !== null && _a !== void 0 ? _a : optionsImage.replace_color,
          source: optionsImage.src
        };
        img.addEventListener("load", function () {
          if (_this2.image) {
            _this2.image.loaded = true;
            image.element = img;
          }

          domUrl.revokeObjectURL(url);
        });
        img.addEventListener("error", function () {
          domUrl.revokeObjectURL(url);
          Utils_1.Utils.loadImage(optionsImage.src).then(function (img2) {
            if (_this2.image) {
              image.element = img2.element;
              _this2.image.loaded = true;
            }
          });
        });
        img.src = url;
      } else {
        imageRes = {
          data: image,
          loaded: true,
          ratio: optionsImage.width / optionsImage.height,
          replaceColor: (_b = optionsImage.replaceColor) !== null && _b !== void 0 ? _b : optionsImage.replace_color,
          source: optionsImage.src
        };
      }

      if (!imageRes.ratio) {
        imageRes.ratio = 1;
      }

      var fill = (_c = optionsImage.fill) !== null && _c !== void 0 ? _c : this.fill;
      var close = (_d = optionsImage.close) !== null && _d !== void 0 ? _d : this.close;
      return {
        image: imageRes,
        fill: fill,
        close: close
      };
    }
  }]);

  return Particle;
}();

exports.Particle = Particle;